import { render } from "./CIS-ContentBlock.vue?vue&type=template&id=04b9d368"
import script from "./CIS-ContentBlock.vue?vue&type=script&lang=js"
export * from "./CIS-ContentBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__